import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { ModalService } from '../../common/modal/modal-service';
import { v4 as uuid } from 'uuid';
import { form, FormField } from '@angular/forms/signals';
import { AttendingStatus } from '../../../models/AttendingStatus.enum';
import { RsvpData } from '../../../models/RsvpData';
import { InvitationType } from '../../../models/InvitationType.enum';
import { InvitationTypeIconPipe } from "../../../pipes/invitation-type-icon-pipe";
import { attendingIconPipe } from "../../../pipes/attending-icon-pipe-pipe";
import { ToastrService } from 'ngx-toastr';
import { UpdateService } from '../../../services/update-service';

@Component({
  selector: 'app-create-new-family',
  imports: [InvitationTypeIconPipe, FormField, attendingIconPipe],
  templateUrl: './create-new-family.html',
  styleUrl: 'create-new-family.scss',
})
export class CreateNewFamily {
  readonly message = input('');
  readonly modalService = inject(ModalService);
  private toastrService = inject(ToastrService);
  private updateService = inject(UpdateService);

  newFamilyUuid = uuid().toString();

  attendingStatusOptions = [
    AttendingStatus.NOT_RESPONDED,
    AttendingStatus.ATTENDING,
    AttendingStatus.NOT_ATTENDING,
    AttendingStatus.NOT_SURE_YET,
  ];

  invitationTypesOptions = [
    InvitationType.EMPTY,
    InvitationType.FAMILLE,
    InvitationType.AMIS,
    InvitationType.AMIS_PARENTS,
    InvitationType.VH,
    InvitationType.VH_PARENTS
  ];

  familyPrivateDataModel = signal({
    canInviteChildren: false,
    canInviteCouple: false,
    invitationType: InvitationType.EMPTY.getKey(),
    departement: ''
  });

  rsvpDataModel = signal<RsvpData>({
    person1: { firstName: "", lastName: "", adult: true, personId: uuid().toString() },
    person2: undefined,
    childs: [],
    attendingStatus: AttendingStatus.NOT_RESPONDED.getKey(),
    comment: '',
    bonusQuestionAnswer: '',
    staysForBrunch: false,
  });

  familyPrivateDataForm = form(this.familyPrivateDataModel);
  rsvpDataForm = form(this.rsvpDataModel);

  buttonConfimDisabled = computed(
    () => this.familyPrivateDataModel().invitationType === InvitationType.EMPTY.getKey()
      || this.rsvpDataModel().person1.lastName === '' || this.rsvpDataModel().person1.firstName === ''
      || (this.familyPrivateDataModel().departement.length !== 2 && this.familyPrivateDataModel().departement.length !== 3)
  );
  constructor() {
    effect(() => {
      if (!this.familyPrivateDataModel().canInviteCouple) {
        this.removeAdult('person2');
      };
    });
  }

  addChild() {
    this.rsvpDataModel.update(data => ({
      ...data,
      childs: [...data.childs!, { firstName: "", lastName: "", adult: false, personId: uuid().toString() }],
    }));
    this.rsvpDataForm().markAsDirty();
  }

  removeChild(index: number) {
    this.rsvpDataModel.update(data => ({
      ...data,
      childs: data.childs!.filter((_, i) => i !== index),
    }));
    this.rsvpDataForm().markAsDirty();
  }

   removeAdult(key: 'person1' | 'person2') {
    if (key === 'person1') {
      this.rsvpDataModel.update(data => ({
        ...data,
        ['person1']: this.rsvpDataModel().person2!,
      }));
    }

    this.rsvpDataModel.update(data => ({
      ...data,
      ['person2']: undefined,
    }));
    this.rsvpDataForm().markAsDirty();
  }

  addAdult() {
    this.rsvpDataModel.update(data => ({
      ...data,
      ['person2']: { firstName: "", lastName: "", adult: true, personId: uuid().toString() },
    }));
    this.rsvpDataForm().markAsDirty();
  }

  validate(): void {
    if (!this.buttonConfimDisabled()) {
      this.updateService.createNewFamily(this.newFamilyUuid, this.rsvpDataModel(), this.familyPrivateDataModel())
        .then(val => {
          if (val) {
            this.toastrService.success('Famille sauvegardée');
            this.modalService.shouldClose.set(true);
          } else {
            this.toastrService.error('Erreur de creation');
            this.modalService.discardModal(false);
          }
        })
        .catch(() => {
          this.toastrService.error('Erreur de creation');
          this.modalService.discardModal(false);
        });
    }

  }

}
